export default __webpack_public_path__ + "ffbdfdee29b25dcf50542e92ee38ca53.png";